import { useState } from 'react';
import { Field, Deposit, Section, Horizon, Bed } from '../types/types';

export const useModals = () => {
    const [fieldModal, setFieldModal] = useState<{ isOpen: boolean; field?: Field | null }>({ isOpen: false, field: null });
    const [depositModal, setDepositModal] = useState<{ isOpen: boolean; fieldId: string; deposit?: Deposit | null }>({ isOpen: false, fieldId: '', deposit: null });
    const [sectionModal, setSectionModal] = useState<{ isOpen: boolean; fieldId: string; depositId: string; section?: Section | null }>({ isOpen: false, fieldId: '', depositId: '', section: null });
    const [horizonModal, setHorizonModal] = useState<{ isOpen: boolean; fieldId: string; depositId: string; sectionId: string; horizon?: Horizon | null }>({ isOpen: false, fieldId: '', depositId: '', sectionId: '', horizon: null });
    const [bedModal, setBedModal] = useState<{ isOpen: boolean; fieldId: string; depositId: string; sectionId: string; horizonId: string; bed?: Bed | null }>({ isOpen: false, fieldId: '', depositId: '', sectionId: '', horizonId: '', bed: null });

    // Локальные состояния для каждого уровня
    const [localField, setLocalField] = useState<Field | null>(null);
    const [localDeposit, setLocalDeposit] = useState<Deposit | null>(null);
    const [localSection, setLocalSection] = useState<Section | null>(null);
    const [localHorizon, setLocalHorizon] = useState<Horizon | null>(null);
    const [localBed, setLocalBed] = useState<Bed | null>(null);

    // Функции для добавления сущностей
    const handleAddField = () => {
        setLocalField({
            id: '',
            name: '',
            deposits: [],
            wells: [],
            company: null,
            type: null,
            stage: '',
            district: '',
            fondMining: '',
            fondInjection: '',
            description: ''
        });
        setFieldModal({ isOpen: true, field: null });
    };

    const handleAddDeposit = (fieldId: string) => {
        setLocalDeposit({
            id: '',
            name: '',
            sections: [],
            company: null,
            type: null,
            fondMining: '',
            fondInjection: '',
            description: ''
        });
        setDepositModal({ isOpen: true, fieldId, deposit: null });
    };

    const handleAddSection = (fieldId: string, depositId: string) => {
        setLocalSection({
            id: '',
            name: '',
            horizons: [],
            company: null,
            fondMining: '',
            fondInjection: '',
            description: ''
        });
        setSectionModal({ isOpen: true, fieldId, depositId, section: null });
    };

    const handleAddHorizon = (fieldId: string, depositId: string, sectionId: string) => {
        setLocalHorizon({
            id: '',
            name: '',
            beds: [],
            cipher: '',
            depth: '',
            description: ''
        });
        setHorizonModal({ isOpen: true, fieldId, depositId, sectionId, horizon: null });
    };

    const handleAddBed = (fieldId: string, depositId: string, sectionId: string, horizonId: string) => {
        setLocalBed({
            id: '',
            name: '',
            depth: '',
            porosity: '',
            permeability: '',
            thickness: '',
            reservoirType: null,
            description: ''
        });
        setBedModal({ isOpen: true, fieldId, depositId, sectionId, horizonId, bed: null });
    };

    // Функции для редактирования сущностей
    const handleEditField = (field: Field) => {
        setLocalField({ ...field });
        setFieldModal({ isOpen: true, field });
    };

    const handleEditDeposit = (fieldId: string, deposit: Deposit) => {
        setLocalDeposit({ ...deposit });
        setDepositModal({ isOpen: true, fieldId, deposit });
    };

    const handleEditSection = (fieldId: string, depositId: string, section: Section) => {
        setLocalSection({ ...section });
        setSectionModal({ isOpen: true, fieldId, depositId, section });
    };

    const handleEditHorizon = (fieldId: string, depositId: string, sectionId: string, horizon: Horizon) => {
        setLocalHorizon({ ...horizon });
        setHorizonModal({ isOpen: true, fieldId, depositId, sectionId, horizon });
    };

    const handleEditBed = (fieldId: string, depositId: string, sectionId: string, horizonId: string, bed: Bed) => {
        setLocalBed({ ...bed });
        setBedModal({ isOpen: true, fieldId, depositId, sectionId, horizonId, bed });
    };

    return {
        fieldModal,
        setFieldModal,
        depositModal,
        setDepositModal,
        sectionModal,
        setSectionModal,
        horizonModal,
        setHorizonModal,
        bedModal,
        setBedModal,
        localField,
        setLocalField,
        localDeposit,
        setLocalDeposit,
        localSection,
        setLocalSection,
        localHorizon,
        setLocalHorizon,
        localBed,
        setLocalBed,
        handleAddField,
        handleAddDeposit,
        handleAddSection,
        handleAddHorizon,
        handleAddBed,
        handleEditField,
        handleEditDeposit,
        handleEditSection,
        handleEditHorizon,
        handleEditBed
    };
};